(function () {
  'use strict';

  var CAPTIONS = {
    front: 'Front view · Live configuration',
    close: 'Close-up · Diamond and setting',
    scale: 'On-body view · Scale reference',
    gift: 'Signature packaging',
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-root]').forEach(initProductSection);
  });

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + parts[0] + ',' + parts[1];
  }

  function initProductSection(root) {
    var id = root.dataset.sectionId;
    var jsonTag = document.querySelector('[data-product-json="' + id + '"]');
    if (!jsonTag) return;

    var product = JSON.parse(jsonTag.textContent);
    var variants = product.variants;
    var optionNames = product.options;

    var imagesByVariant = {};
    variants.forEach(function (v) {
      var image = v.featured_image;
      if (!image || !image.src) return;
      var angle = (image.alt || 'front').trim().toLowerCase();
      if (!CAPTIONS.hasOwnProperty(angle)) angle = 'front';
      imagesByVariant[v.id] = imagesByVariant[v.id] || {};
      imagesByVariant[v.id][angle] = image.src.indexOf('//') === 0 ? 'https:' + image.src : image.src;
    });

    var currentAngle = 'front';

    var state = {};
    var initialVariant = product.selected_or_first_available_variant || variants.find(function (v) { return v.available; }) || variants[0];
    optionNames.forEach(function (name, i) {
      state[name] = initialVariant['option' + (i + 1)];
    });

    var requestedLight = new URLSearchParams(window.location.search).get('light');
    var lightOptionName = optionNames.find(function (n) { return n === 'Diamond Light'; });
    if (requestedLight && lightOptionName) {
      var wantedWord = requestedLight.charAt(0).toUpperCase() + requestedLight.slice(1).toLowerCase();
      var match = variants.map(function (v) { return v['option' + (optionNames.indexOf(lightOptionName) + 1)]; })
        .find(function (val) { return val && val.indexOf(wantedWord) !== -1; });
      if (match) state[lightOptionName] = match;
    }

    var requestedMetal = new URLSearchParams(window.location.search).get('metal');
    var metalOptionName = optionNames.find(function (n) { return n === 'Metal'; });
    if (requestedMetal && metalOptionName) {
      var wantedMetal = requestedMetal.replace(/-/g, ' ').toLowerCase();
      var metalMatch = variants.map(function (v) { return v['option' + (optionNames.indexOf(metalOptionName) + 1)]; })
        .find(function (val) { return val && val.toLowerCase() === wantedMetal; });
      if (metalMatch) state[metalOptionName] = metalMatch;
    }

    var ANGLE_WORDS = [['on-body', 'scale'], ['close-up', 'close'], ['packaging', 'gift']];
    var extraImages = {};
    var anyPackaging = null;
    // A packaging photo picked in the theme editor wins for every product, metal and light.
    var sharedPackaging = root.getAttribute('data-packaging-image');
    if (sharedPackaging && sharedPackaging.indexOf('//') === 0) sharedPackaging = 'https:' + sharedPackaging;
    (product.images || []).forEach(function (src) {
      var name = String(src).split('/').pop().split('?')[0].toLowerCase();
      var angle = null;
      ANGLE_WORDS.forEach(function (pair) { if (name.indexOf(pair[0]) !== -1) angle = pair[1]; });
      if (!angle) return;
      var url = src.indexOf('//') === 0 ? 'https:' + src : src;
      // The gift box is the same for every piece, so one packaging photo covers every metal and light.
      if (angle === 'gift' && !anyPackaging) anyPackaging = url;
      var metal = name.indexOf('yellow-gold') !== -1 ? 'yellow-gold' : (name.indexOf('white-gold') !== -1 ? 'white-gold' : null);
      if (!metal) return;
      var rest = name.replace(metal, '');
      var light = /pink/.test(rest) ? 'pink' : /blue/.test(rest) ? 'blue' : /green/.test(rest) ? 'green' : /yellow/.test(rest) ? 'yellow' : 'white';
      var key = metal + '|' + light;
      extraImages[key] = extraImages[key] || {};
      extraImages[key][angle] = src.indexOf('//') === 0 ? 'https:' + src : src;
    });

    function findVariant() {
      return variants.find(function (v) {
        return optionNames.every(function (name, i) {
          return v['option' + (i + 1)] === state[name];
        });
      });
    }

    function isOptionValueAvailable(name, value) {
      return variants.some(function (v) {
        var matches = optionNames.every(function (n, i) {
          if (n === name) return v['option' + (i + 1)] === value;
          return v['option' + (i + 1)] === state[n];
        });
        return matches && v.available;
      });
    }

    function render() {
      var variant = findVariant();
      var lightValue = state['Diamond Light'];
      var lightSwatch = lightValue ? root.querySelector('[data-option-value="' + lightValue + '"][data-light-name]') : null;
      var meta = lightSwatch ? { name: lightSwatch.dataset.lightName, meaning: lightSwatch.dataset.lightMeaning } : null;

      root.querySelectorAll('[data-option-group]').forEach(function (group) {
        var name = group.dataset.optionGroup;
        group.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var val = btn.dataset.optionValue;
          btn.classList.toggle('active', state[name] === val);
          btn.disabled = !isOptionValueAvailable(name, val);
        });
      });

      setText(root, '.caratLabel', state['Carat'] || '');
      setText(root, '.metalLabel', state['Metal'] || '');
      if (meta) {
        setText(root, '.stoneLabel', meta.name);
        setText(root, '.meaning', meta.meaning);
        setText(root, '.summaryStone', meta.name);
      }
      setText(root, '.summaryCarat', state['Carat'] || '');
      setMetalSummary(root, state['Metal']);
      root.querySelectorAll('[data-white-gold-only]').forEach(function (row) {
        row.hidden = !/white/i.test(state['Metal'] || '');
      });

      var placeholderText = root.querySelector('.js-product-placeholder .placeholder-frame span');
      if (placeholderText) {
        var metalText = state['Metal'] ? ' · ' + metalDisplay(root, state['Metal']) : '';
        placeholderText.innerHTML = product.title + '<br>' + (state['Carat'] || '') + ' · ' + (meta ? meta.name : '') + metalText;
      }

      var imgEl = root.querySelector('.js-product-image');
      var placeholderEl = root.querySelector('.js-product-placeholder');
      var metalKey = (state['Metal'] || '').toLowerCase().replace(/\s+/g, '-');
      var lightMatch = /white|pink|blue|green|yellow/.exec((state['Diamond Light'] || '').toLowerCase());
      var extra = extraImages[metalKey + '|' + (lightMatch ? lightMatch[0] : 'white')];
      function photoFor(angle) {
        if (angle === 'gift' && sharedPackaging) return sharedPackaging;
        return (extra && extra[angle]) || (variant && imagesByVariant[variant.id] ? imagesByVariant[variant.id][angle] : null) || (angle === 'gift' ? anyPackaging : null);
      }
      var photoUrl = photoFor(currentAngle);
      root.querySelectorAll('.thumb').forEach(function (t) {
        var thumbImg = t.querySelector('img');
        var url = photoFor(t.dataset.view);
        if (!thumbImg) return;
        if (url) {
          thumbImg.src = url.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2');
          thumbImg.hidden = false;
          t.classList.add('has-photo');
        } else {
          thumbImg.hidden = true;
          t.classList.remove('has-photo');
        }
      });
      if (imgEl && placeholderEl) {
        if (photoUrl) {
          if (imgEl.getAttribute('src') !== photoUrl) {
            // The server-rendered srcset would otherwise keep showing the first photo.
            imgEl.removeAttribute('srcset');
            imgEl.removeAttribute('sizes');
            imgEl.src = photoUrl;
          }
          imgEl.alt = [product.title, metalDisplay(root, state['Metal']), meta ? meta.name + ' lab-grown diamond' : '', CAPTIONS[currentAngle] && currentAngle !== 'front' ? CAPTIONS[currentAngle].split(' · ')[0] : '']
            .filter(Boolean).join(', ');
          imgEl.style.display = 'block';
          // Lets CSS keep a necklace pendant in frame on portrait on-body photos.
          imgEl.dataset.view = currentAngle;
          imgEl.classList.toggle('is-necklace', /necklace/.test(product.handle || ''));
          placeholderEl.style.display = 'none';
        } else {
          imgEl.style.display = 'none';
          placeholderEl.style.display = 'flex';
        }
      }

      var variantInput = root.querySelector('input[id^="selectedVariantId-"]');
      var addBtn = root.querySelector('button[id^="addToCartBtn-"]');
      var summaryPrice = root.querySelector('[id^="summaryPrice-"]');

      if (variant) {
        if (variantInput) variantInput.value = variant.id;
        if (summaryPrice) summaryPrice.textContent = formatMoney(variant.price);
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? addBtn.dataset.addLabel : addBtn.dataset.unavailableLabel;
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.selectOptionsLabel;
      }
    }

  function metalDisplay(root, metal) {
    if (!metal) return '';
    var prefix = root.getAttribute('data-metal-prefix');
    return prefix ? prefix + ' ' + metal : metal;
  }

  // Summary row: metal name followed by a small karat hallmark box.
  function setMetalSummary(root, metal) {
    root.querySelectorAll('.summaryMetal').forEach(function (el) {
      el.textContent = metal || '';
      var prefix = root.getAttribute('data-metal-prefix');
      if (!metal || !prefix) return;
      var mark = document.createElement('span');
      mark.className = 'karat-mark karat-mark--sm';
      mark.textContent = prefix;
      el.appendChild(mark);
    });
  }

  function setText(scope, selector, text) {
      var el = scope.querySelector(selector);
      if (el) el.textContent = text;
    }

    root.querySelectorAll('[data-option-group] [data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var group = btn.closest('[data-option-group]');
        state[group.dataset.optionGroup] = btn.dataset.optionValue;
        render();
      });
    });

    var thumbs = root.querySelectorAll('.thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        currentAngle = t.dataset.view;
        var caption = root.querySelector('[id^="productCaption-"]');
        if (caption) caption.textContent = CAPTIONS[currentAngle] || '';
        render();
      });
    });

    render();
  }
})();
